export const TargetType = {
  Account: 'Account',
  Physical: 'Physical',
  Juridical: 'Juridical',
};

export const PersonType = {
  All: 'All',
  Physical: 'Physical',
  Juridical: 'Juridical',
};

export const CivilStatus = {
  Single: 'Single',
  Engaged: 'Engaged',
  Married: 'Married',
  Divorced: 'Divorced',
  Widower: 'Widower',
};

export function getTargetTypeName(type) {
  return type;
}

export const PhysicalPersonRelationshipAccount = {
  Attorney: 'Attorney',
  Holder: 'Holder',
  Beneficiary: 'Beneficiary',
};

export const PhysicalPersonRelationshipAccountJuridical = {
  Attorney: 'Attorney',
  Representative: 'Representative',
  None: 'None',
  WebAuthorized: 'WebAuthorized',
  Holder: 'Holder',
};

export const OptionsWhyWithoutTIN = [{
  id: 'Option1',
  text: 'El país donde el titular de la cuenta está sujeto a impuestos tributarios como residente no emite TIN.',
}, {
  id: 'Option2',
  text: 'El titular de la cuenta está imposibilitado de otra manera para obtener un TIN o número equivalente.',
}, {
  id: 'Option3',
  text: 'No se requiere TIN porque la jurisdicción de la residencia fiscal que emitió el TIN no exige que una Institución Financiera recolecte e informe el TIN.',
}];

export const DocumentType = {
  DNI: 'DNI',
  Passport: 'Passport',
  IdentityCard: 'Identity Card',
};
